import { metricKeys } from '@pulse/metrics';
import { DATASET } from '@utils/constants';
import { DEFAULT_KPI_ID } from '@src/utils/kpi';
import { get } from 'lodash';
import { adContentMap, AD_CONTENT_DIMENSION } from '@utils/adContent/mappings';

const AD_SPI_METRICS = [metricKeys.StreamingPerformanceIndex, metricKeys.SpiStreams];

const baseQuery = {
  type: 'group-by',
  dataset: DATASET,
  metrics: AD_SPI_METRICS,
  interval: '2018-12-19T22:35:18.907Z/2018-12-20T22:35:18.907Z',
  granularity: 'ALL',
  filter: [],
  limit: 3, // true, false or unknown
  groupBy: [AD_CONTENT_DIMENSION],
  orderBy: 'desc',
  sortBy: [{ metric: metricKeys.SpiStreams, order: 'desc' }],
  options: {
    withTotals: true,
    withOverviewThresholds: true,
    selectedKpiId: DEFAULT_KPI_ID,
    kpiConfig: {},
  },
};

const createQuery = ({ interval, filter, selectedKpiId, kpiConfig }) => {
  const query = {
    ...baseQuery,
    interval,
    filter,
  };
  query.options.selectedKpiId = selectedKpiId;
  query.options.kpiConfig = kpiConfig;
  return query;
};

const formatAdContentData = ({ response }) => {
  try {
    if (response) {
      const results = get(response, 'data.0.results');
      const totals = get(response, 'totals.0.results');

      const rows = {};
      results.forEach((row) => {
        const key = row[AD_CONTENT_DIMENSION];
        if (key in adContentMap) {
          const SpiStreamsPct = (row[metricKeys.SpiStreams] * 100) / totals[metricKeys.SpiStreams];
          rows[adContentMap[key]] = { ...row, SpiStreamsPct };
        }
      });
      return rows;
    }
  } catch (err) {
    // ignore
  }
  return null;
};

export { createQuery, formatAdContentData };
